import { Button, Checkbox, Modal, Text } from '@mercai/clever'

import { useTranslation } from 'react-i18next'

import { useCookieState } from '@/helpers'

import { DuplicateQuotationModalProps } from './duplicate-quotation-modal.type'
import styles from './duplicate-quotation-modal.module.css'

export const DuplicateQuotationModal = ({
  isOpen,
  onHandleClose,
  onHandleSubmit,
}: DuplicateQuotationModalProps) => {
  const { t } = useTranslation('screenQuotationV2List')

  const [dontShowDuplicateWarning, setDontShowDuplicateWarning] =
    useCookieState<boolean>('dont-show-duplicate-quotation-warning', false)

  const onHandleMessage = (val: boolean) => {
    setDontShowDuplicateWarning(val)
  }

  return (
    <Modal.Root isOpen={isOpen} onHandleOpen={onHandleClose} size="small">
      <Modal.Body className={styles['modal-body']}>
        <div className={styles['modal-header']}>
          <Text variant="text-large-bold">
            {t('quotationTableDuplicateQuotatioTitle')}
          </Text>
        </div>

        <Text variant="text-base">
          {t('quotationTableDuplicateQuotatioDescription')}
        </Text>

        <Text variant="text-base">
          {t('quotationTableDuplicateQuotatioDescription2')}
        </Text>

        <Checkbox value={dontShowDuplicateWarning} onChange={onHandleMessage}>
          {t('quotationTableDuplicateQuotatioDontShowMessageAgainlButton')}
        </Checkbox>

        <div className={styles['modal-footer']}>
          <Button variant="secondary" onClick={onHandleClose}>
            {t('quotationTableDuplicateQuotatioCancelButton')}
          </Button>
          <Button variant="primary" onClick={onHandleSubmit}>
            {t('quotationTableDuplicateQuotatioConfirmButton')}
          </Button>
        </div>
      </Modal.Body>
    </Modal.Root>
  )
}
